export default {
  home: {
    main: "首页",
  },
};
